import { render, staticRenderFns } from "./dash_calldist.vue?vue&type=template&id=32238f5e&scoped=true&"
import script from "./dash_calldist.vue?vue&type=script&lang=js&"
export * from "./dash_calldist.vue?vue&type=script&lang=js&"
import style0 from "./dash_calldist.vue?vue&type=style&index=0&id=32238f5e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32238f5e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/nico/Projects/ecopbx-web/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {VCard,VCardText,VFlex,VLayout})
